/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackGetExportStatus } from "../../funcs/llmFeedbackGetExportStatus.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$llmFeedbackGetExportStatus: ToolDefinition = {
  name: "llm-feedback-get-export-status",
  description: `Get feedback export status

Checks the status and progress of the currently running or most recently completed feedback export job. Restricted to cluster administrators.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await llmFeedbackGetExportStatus(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
